import React from 'react';
import PlanetListView from "./planet-list-view.js";
import EventListView from "./event-list-view.js";
import * as Backend from '../../backend.js';
import * as util from '../../other/util.js';

// The home screen that shows an overview of the empire
class DashboardView extends util.GameComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    refreshState() {
        Backend.getDashboardInfo((res) => {
            if (res.player.planets.length === 0) {
                this.props.navigate('/game/quests/' + 0, { replace: true });
                return;
            }
            this.setState({ player: res.player });
        });
    }

    render() {
        if (!this.hasCurrentState()) {
            return (<util.LoadingBar2 />);
        }

        let player = this.state.player;
        return (
            <div className="fade-in" key={Math.random()}>
                <EventListView events={player.events} />
                <PlanetListView planets={player.planets} />
                <br />
                <util.JsonDebug obj={player} />
            </div>
        );
    }
}

export default util.withNavigation(DashboardView);